import { Icon } from '@arco-design/web-react';
import { IconProps } from '@arco-design/web-react/es/Icon';
import React, { CSSProperties } from 'react';

/** iconBox导出cdn地址，以更新图标 */
export const fontResourceUrl =
  'https://sf3-cdn-tos.toutiaostatic.com/obj/iconfont/index_3e9ecefb74b0a2fd2bee95d0d4bfa7d6.js'; // cdn链接
export const IconFontBox = Icon.addFromIconFontCn({
  src: fontResourceUrl,
}) as React.FC<IconProps & { style?: CSSProperties }>;

export const IconFont: React.FC<IconProps & { style?: CSSProperties }> =
  props => {
    return <IconFontBox {...props} type={`arco-${props?.type || ''}`} />;
  };

export default IconFont;
